// import { configureStore } from '@reduxjs/toolkit';
// import authReducer from './authSlice';

// const store = configureStore({
//   reducer: {
//     auth: authReducer,
//   },
// });

// export default store;




// import { configureStore } from "@reduxjs/toolkit";
// import userReducer from "./userSlice"; // Import the user slice

// // Configure the store
// const store = configureStore({
//   reducer: {
//     user: userReducer, // Integrate the user slice
//     // Add more slices here if needed
//   },
// });

// export default store;



// import { configureStore, createSlice } from "@reduxjs/toolkit";


// const authSlice = createSlice({
//     name: "auth",
//     initialState: { isLoggedIn: false},
//     reducers: {
//         login(state) {
//             state.isLoggedIn = true;
//         },
//         logout(state) {
//             state.isLoggedIn = false;
//         }
//     }
// });


// export const authActions = authSlice.actions;


// export const store = configureStore({
//     reducer: authSlice.reducer
// })



// store/index.js
// import { configureStore, createSlice } from "@reduxjs/toolkit";

// // Retrieve the initial login state from localStorage
// const initialLoginState = localStorage.getItem("isLoggedIn") === "true";

// const authSlice = createSlice({
//     name: "auth",
//     initialState: { isLoggedIn: initialLoginState },
//     reducers: {
//         login(state) {
//             state.isLoggedIn = true;
//             localStorage.setItem("isLoggedIn", "true"); // Persist login state
//         },
//         logout(state) {
//             state.isLoggedIn = false;
//             localStorage.removeItem("isLoggedIn"); // Clear login state on logout
//             localStorage.clear();
//         }
//     }
// });

// export const authActions = authSlice.actions;

// export const store = configureStore({
//     reducer: authSlice.reducer
// });





import { configureStore, createSlice } from "@reduxjs/toolkit";

// Helper function to validate localStorage keys
const areRequiredKeysPresent = () => {
  const requiredKeys = ["company_id", "company_name", "email_id", "isLoggedIn", "packages", "token", "user_id"];
  return requiredKeys.every((key) => {
    const value = localStorage.getItem(key);
    return value !== null && value !== "undefined" && value !== "";
  });
};

// Set initial login state based on localStorage validation
const initialLoginState = localStorage.getItem("isLoggedIn") === "true" && areRequiredKeysPresent();

const authSlice = createSlice({
  name: "auth",
  initialState: { isLoggedIn: initialLoginState },
  reducers: {
    login(state) {
      if (areRequiredKeysPresent()) {
        state.isLoggedIn = true;
        localStorage.setItem("isLoggedIn", "true"); // Persist login state
      } else {
        state.isLoggedIn = false;
        localStorage.clear(); // Clear localStorage if validation fails
      }
    },
    logout(state) {
      state.isLoggedIn = false;
      localStorage.clear(); // Clear all localStorage items on logout
    }
  }
});

export const authActions = authSlice.actions;

export const store = configureStore({
  reducer: authSlice.reducer,
});
